import React from 'react';

import { MenuItem } from '@/shared/ui';
import { Select, TSelectProps } from '@/shared/ui/lib/Select';

import { LocaleMap } from '../model/types';

const availableLocales: LocaleMap = {
  en: 'English',
  ru: 'Русский',
};

export const LanguageSelect = ({ value, onChange }: TSelectProps) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      size="small"
      variant="outlined"
      sx={{ minWidth: 106 }}
    >
      {Object.entries(availableLocales).map(([itemValue, label]) => (
        <MenuItem key={itemValue} value={itemValue}>
          {label}
        </MenuItem>
      ))}
    </Select>
  );
};
